import api from "../lib/axios";

/**
 * Fetch all favorite exhibitors for the current site user
 * @param {string|number} eventId 
 */
export const getFavorites = async (eventId) => {
    return api.get(`/site/mylist/${eventId}`, {
        headers: {
            "ngrok-skip-browser-warning": "true",
        },
    });
};

/**
 * Toggle favorite status for an exhibitor
 * @param {string|number} eventId 
 * @param {string|number} exhibitorId 
 */
export const toggleFavorite = async (eventId, exhibitorId) => {
    return api.post(`/site/mylist/${eventId}`, { exhibitor_id: exhibitorId }, {
        headers: {
            "ngrok-skip-browser-warning": "true",
        },
    });
};

/**
 * Remove an exhibitor from favorites
 * @param {string|number} eventId 
 * @param {string|number} exhibitorId 
 */
export const removeFavorite = async (eventId, exhibitorId) => {
    return api.delete(`/site/mylist/${eventId}/${exhibitorId}`, {
        headers: {
            "ngrok-skip-browser-warning": "true",
        },
    });
};
